<script>
    import {createEventDispatcher} from 'svelte/internal';

    export let value;
    export let id = '';
    export let disabled = false;
    export let style = '';

    const dispatch = createEventDispatcher();

    const onChange = () => {
        dispatch("change", value);
    }
</script>
<input type="text" class="form-control" id="{ id }" bind:value="{ value }" {style}
       oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
       on:change={ onChange }
       autocomplete="off" disabled="{ disabled }">
